export default [
    {
        path: 'reterritorializacao',
        component: () => import(
            '@/views/atencao-basica/reterritorializacao/Index'
        ),
        redirect: 'reterritorializacao/create',
        children: [
            {
                name: 'atencao-basica-reterritorializacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-reterritorializacao' */
                    '@/views/atencao-basica/reterritorializacao/Form.vue'
                ),
            },
        ],
    },
]